<ejs-toast #toasttype id='toasttype' (beforeOpen)="onBeforeOpen($event)" (close)="close($event)"
  [position]="toastPosition"></ejs-toast>
<!-- Topbar -->
<div id="header" class="header-section ">
  <div class="toolbar-menu-control ">
    <div id="brandLogo" class="">
      <!--<a class="e-pointer" (click)="gotohome()"></a>-->
      <img alt="" src="../../../../assets/images/syntrio-logo-white.png">
    </div>
    <div id="companyLogo">
      <img style="height: 30px;" alt="" src="{{authService.CurrentCompanyLogo.value}}">
    </div>

    <div id="feedback" content='Feedback' class="menu-item">
      <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=jnfO4ndKjUKp-ox4Sj8fgjrozVW17S9LpHswOW6ZvHRUQkxOUVNVNE9TV0syOE5BTFUyM0ZMQ05XOC4u"
        target="_blank">
        <div class="e-icons e-feedback e-pointer e-2-5x d-flex justify-content-center"></div>
        <div>Feedback</div>
      </a>
    </div>
    <div id="help" content='Help'>
      <a href="https://syntrio.atlassian.net/wiki/spaces/CSHS/overview" target="_blank">
        <i class="e-icons e-help e-pointer e-2-5x d-flex justify-content-center"></i>
        <div><small>Help</small></div>
      </a>
    </div>
    <div id="contact" content='Contact Us'>
      <a href="mailto:reports@syntrio.com" target="_blank">
        <i class="e-icons e-phone e-pointer e-2x d-flex justify-content-center"></i>
        <div><small>Contact Us</small></div>
      </a>
    </div>
    <div id="tutorialVideo" content='Tutorial Videos'>
      <a href="https://syntrio.atlassian.net/wiki/spaces/CSHS/pages/1766621227/Tutorial+Webinar+CMS+Walkthrough?atlOrigin=eyJpIjoiMGZlOTkwMmU2Njk1NDRlNWE1MjQxZjZjZDVmNDE5NGMiLCJwIjoiYyJ9"
        target="_blank">
        <i class="e-icons e-video e-pointer e-2x d-flex justify-content-center"></i>
        <div><small>Tutorial Videos</small></div>
      </a>
    </div>
    <div id="resourcePage" content='Resource Pages'>
      <a href="https://www.lighthouse-services.com/resources" target="_blank"><i
          class="e-icons e-video-laptop e-pointer d-flex justify-content-center"></i>
        <div><small>Resource Pages</small></div>
      </a>
    </div>
    <div id="goToLMS" #goToLMS content='Go To LMS' class="menu-item">
      @if (showLMS) {
      <a href="https://engage.syntrio.com/auth/login" target="_blank"><i
          class="e-icons e-2x e-LMS e-pointer d-flex justify-content-center"></i>
        <div>Go to LMS</div>
      </a>
      }
    </div>
    <div id="goToUniversalIntake" #goToUniversalIntake content='Go To Universal Intake' class="menu-item">
      @if (hasUniversalAdmin) {
      <a href="javascript:void(0)" class="e-pointer">
        <i class="e-icons e-2x e-open-link e-pointer d-flex justify-content-center"></i>
        <div>Universal Intake</div>
      </a>
      }
    </div>
    <div id="moreHidden" #moreHidden content='More Links Hidden' style="visibility: hidden; min-width: 100px;">
      <a href="#" target="_blank"><i class="e-icons e-more-links e-pointer d-flex justify-content-center"></i>
        <div><small>More Links</small></div>
      </a>
    </div>
    <div id="productSwitcher" class="prod-switcher-container menu-item" #productSwitcher></div>
    <div id="userDBtn" class="user-menu-container" #userMenuContainer>
      <button type="button" class="user-icon" (click)="toggleUserMenu()">
        <div class="user-prof-img">
          <img src="../../../assets/images/user-icon.svg" alt="User menu">
        </div>
      </button>
      @if (isUserMenuOpen) {
      <div class="user-menu-dropdown" (clickOutside)="closeUserMenu()">
        <ul>
          <li id="userName" class="user-info">
            <div class="user-name">{{ getUserDisplayName() }}</div>
            <div class="user-email" [title]="getUserEmail()">{{ getUserEmail() }}</div>
          </li>
          @for (item of getVisibleMenuItems(); track item.id) {
            <li [id]="item.id" (click)="onMenuItemClick(item.id)">
              <i [class]="item.iconCss"></i>
              <span>{{ item.text }}</span>
            </li>
          }
        </ul>
      </div>
      }
    </div>
    <div id="emulateBtn" #emulateBtn>
      @if (emulateUserService.CurrentEmulationValue.value) {
      <button type="button" class="btn btn-danger btn-sm" (click)="stopEmulation()">Stop
        Emulation</button>
      }
    </div>
    <ejs-toolbar #toolbar class="e-shadowed e-bigger border-highlight" overflowMode='Popup' width=auto>
      <e-items>
        <e-item [template]='logoTemplate' cssClass='item-brandLogo e-cursor-auto no-link'></e-item>
        <e-item [template]='emulateTemplate' cssClass='no-link'></e-item>
        <e-item [template]='companyLogoTemplate' cssClass='e-cursor-auto no-link' align='center'></e-item>
        <e-item [template]='feedbackTemplate' align='Right'></e-item>
        <e-item [template]='goToLMSTemplate' align='Right'></e-item>
        <e-item [template]='goToUniversalIntakeTemplate' align='Right'></e-item>
        <e-item [template]='moreHiddenTemplate' align='Right'></e-item>
        <e-item [template]='productSwitcherTemplate' align='Right'></e-item>
        <e-item [template]='userActTemplate' cssClass='no-link' align='Right'></e-item>
        <e-item [template]='helpTemplate' align='Right' showAlwaysInPopup=true></e-item>
        <e-item [template]='contactTemplate' align='Right' showAlwaysInPopup=true></e-item>
        <e-item [template]='tutorialVideoTemplate' align='Right' showAlwaysInPopup=true></e-item>
        <e-item [template]='resourcePageTemplate' align='Right' showAlwaysInPopup=true></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
  <div class="account-name-bx bg-highlight e-position-absolute e-px-3 e-text-white e-text-center">
    @if (isLoginTypeCMS && currentUser != null) {
    <span>{{currentUser.Company.Name}}</span>
    }
    @if (!isLoginTypeCMS && respondUser != null) {
    <span>{{respondUser.CompanyName}}</span>
    }
  </div>
</div>